import { render, staticRenderFns } from "./bck_2026-06-23-WorkerIdentificationDocument.vue?vue&type=template&id=cc2c02e6&scoped=true"
import script from "./bck_2026-06-23-WorkerIdentificationDocument.vue?vue&type=script&lang=js"
export * from "./bck_2026-06-23-WorkerIdentificationDocument.vue?vue&type=script&lang=js"
import style0 from "./bck_2026-06-23-WorkerIdentificationDocument.vue?vue&type=style&index=0&id=cc2c02e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2c02e6",
  null
  
)

export default component.exports